import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	filtersHeader: {
		id: 'spa-apps-sidebar-filters.global-scope.menu.filters-header',
		defaultMessage: 'Filters',
		description: 'Navigation item which is the title of search issues page sidebar',
	},
	viewAllFilters: {
		id: 'spa-apps-sidebar-filters.global-scope.menu.view-all-filters',
		defaultMessage: 'View all filters',
		description: 'Navigation item which links to the filters directory page',
	},
	newSearch: {
		id: 'spa-apps-sidebar-filters.global-scope.menu.new-search',
		defaultMessage: 'New search',
		description: 'Navigation item which links to a search issues page',
	},
});
